<template>
  <v-row>
    <v-col cols="12">
      <v-row justify="end" class="mt-1">
        <v-col cols="2">
          <v-select
            dense
            outlined
            v-model="productId"
            :items="products"
            item-text="planName"
            item-value="planId"
            label="Plano"
            :clearable="true"
            :loading="isLoadingPlans"
            @change="loadItems"
          ></v-select>
        </v-col>
      </v-row>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalElements"
        :loading="isSearching"
        item-key="id"
        locale="pt-BR"
        show-select
        class="elevation-3"
      >
        <template v-slot:item.description="{item}">
          <coverage-descriptions
            :item="item"
            :coverage-descriptions="getCoverageDescriptions"
            @on-description-created="updateCoveragePlan"
            class="mt-1 mb-1"
          >
          </coverage-descriptions>
        </template>
      </v-data-table>
    </v-col>
    <DlgConfirmCancel ref="confirm"></DlgConfirmCancel>
  </v-row>
</template>

<script>
import CoveragePlanService from '@/services/odoo/CoveragePlanService';
import CoverageDescriptions from '@/view/coverage/coverage_descriptions';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import DlgConfirmCancel from '@/components/dlg-confirm_cancel.vue';

export default {
  components: { CoverageDescriptions, DlgConfirmCancel },
  props: {
    coverageId: {
      type: String,
    },
  },
  data() {
    return {
      isLoadingPlans: false,
      headers: [
        {text: 'Operadora', value: 'carrier'},
        {text: 'Código', value: 'planCode'},
        {text: 'Plano', value: 'planName'},
        {text: 'Regra', value: 'description', sortable: false},
      ],
      isSearching: false,
      options: {},
      items: [],
      totalElements: null,
      singleSelect: false,
      selected: [],
      products: [],
      productId: null,
    };
  },
  async created() {
    this._coveragePlanService = new CoveragePlanService();
  },
  watch: {
    options: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters('coverage', ['getCoverageDescriptions']),
  },
  methods: {
    ...mapActions('coverage', ['fetchCoverageDescriptions']),
    ...mapMutations(['toogleDialogLoading', 'showmsg']),
    async updateCoveragePlan(
      coveragePlan,
      coverageDescriptionId,
    ) {
      await this._coveragePlanService.update(coveragePlan.id, coverageDescriptionId);
    },
    async loadData() {
      this.loadItems().then();
      this.loadProducts().then();
    },
    async loadItems() {
      this.isSearching = true;
      const {sortBy, sortDesc, page, itemsPerPage} = this.options;
      this._coveragePlanService
        .findAllByCoverageId(this.coverageId, {
          page: page ? page - 1 : 0,
          sortBy:
            sortBy && sortBy.length
              ? sortBy[0] === 'plan.carrierName'
                ? 'plan.productFamily.carrier.name'
                : sortBy[0]
              : 'plan.productCode',
          descending: sortDesc && sortDesc.length ? sortDesc[0] : false,
          size: itemsPerPage,
          planId: this.productId,
        })
        .then((res) => {
          this.items = res.data.content;
          this.totalElements = res.data.totalElements;
          this.isSearching = false;
          this.$emit('on-load');
        });

      if (!this.getCoverageDescriptions.length) {
        this.fetchCoverageDescriptions().then();
      }
    },
    async loadProducts() {
      this.isLoadingPlans = true;
      this.products = [];
      this._coveragePlanService
        .findAllByCoverageId(this.coverageId, {
          page: 0,
          sortBy: 'plan.description',
          descending: false,
          size: this.totalElements,
        })
        .then((res) => {
          this.products = res.data.content;
        }).finally(() => {
          this.isLoadingPlans = false;
        });
    },
    async removeAll() {
      if (
        this.selected.length &&
        (await this.$refs.confirm.show(
          'Atenção',
          'Deseja excluir os registros selecionados?',
        ))
      ) {
        this.toogleDialogLoading(true);
        try {
          for (const coveragePlan of this.selected) {
            await this._coveragePlanService.delete(coveragePlan.id);
          }
          this.showmsg({text: 'Planos desassociados com sucesso!'});
        } catch (error) {
          this.showmsg({text: 'Erro ao desassociaar Planos!'});
        }

        this.toogleDialogLoading(false);
        await this.loadData();
      }
    },
  },
};
</script>
